/**
 * DOM utilities — show / hide / toggle helpers.
 * Used by all component modules.
 */

/**
 * Shows a DOM element by removing the is-hidden class and hidden attribute.
 * @param {HTMLElement} el
 */
export function showElement(el) {
  el.classList.remove("is-hidden");
  el.removeAttribute("hidden");
}

/**
 * Hides a DOM element by adding the is-hidden class and hidden attribute.
 * @param {HTMLElement} el
 */
export function hideElement(el) {
  el.classList.add("is-hidden");
  el.setAttribute("hidden", "");
}

/**
 * Conditionally shows or hides a DOM element.
 * @param {HTMLElement} el
 * @param {boolean} show - true to show, false to hide
 */
export function toggleElement(el, show) {
  if (show) {
    showElement(el);
  } else {
    hideElement(el);
  }
}

export function query(selector, context = document) {
  return context.querySelector(selector);
}

export function queryAll(selector, context = document) {
  return [...context.querySelectorAll(selector)];
}

export function setExpanded(el, expanded) {
  el.setAttribute('aria-expanded', String(expanded));
}

export function setAriaLabel(el, label) {
  el.setAttribute('aria-label', label);
}

export function bindAll(selector, event, handler, context = document) {
  queryAll(selector, context).forEach(el => el.addEventListener(event, handler));
}

export function parseIntData(el, key) {
  return parseInt(el.dataset[key], 10);
}

/**
 * Returns the shared full-page dimming overlay, creating it (hidden) on first use.
 * @returns {HTMLElement}
 */
export function getScreenOverlay() {
  let overlay = document.querySelector(".screen-overlay");
  if (!overlay) {
    overlay = document.createElement("div");
    overlay.className = "screen-overlay";
    hideElement(overlay);
    document.body.appendChild(overlay);
  }
  return overlay;
}
